import { ResolveFn } from '@angular/router';

export const dataResolver: ResolveFn<any> = () => ({ res: 'I am data' });

/**
 * An array of services to resolve routes with data.
 */
export const APP_RESOLVER_PROVIDERS: any[] = [];
